<script setup lang="ts">
import { UiCard, UiButton, UiText, UiAccordion, UiIcon } from "@shopexperts/shared";
import DragHandle from "@/components/common/DragHandle.vue";
import type { Faq } from "./types/listingModels";

const props = defineProps<{
  item: Faq;
  index?: number;
}>();

const emit = defineEmits<{
  (e: 'edit'): void;
  (e: 'delete'): void;
}>();

function onEditClick() {
  emit('edit');
}

function onDeleteClick() {
  emit('delete');
}
</script>

<template>
  <UiCard padding="md" class="relative draggable-item">
    <div class="flex items-start justify-between gap-4">
      <div class="flex-1">
        <UiAccordion icon="arrow-badge" trigger-spread="sm" class="py-1">
          <template #trigger>
            <div class="flex items-center gap-2">
              <UiText as="span" variant="p" :text="props.item.question" />
            </div>
          </template>
          <div class="pt-4">
            <UiText as="p" variant="p-small" class="text-gray-600" :text="props.item.answer" />
          </div>
        </UiAccordion>
      </div>

      <div class="flex items-center gap-2 flex-shrink-0">
        <UiButton variant="outline" shape="icon" @click="onEditClick" no-py class="p-1.5">
          <template #before_label>
            <UiIcon name="pencil" class="w-4.5 h-4.5" />
          </template>
        </UiButton>
        <UiButton variant="outline" shape="icon" @click="onDeleteClick" no-py class="p-1.5">
          <template #before_label>
            <UiIcon name="delete" class="w-4.5 h-4.5" />
          </template>
        </UiButton>
      </div>
      <DragHandle />
    </div>
  </UiCard>
</template>
